import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { useStorageAreaStore } from "shared/storageAreas/stores/storageAreaStore";

export interface DeleteStorageAreaRequest {
  storageAreaId: string;
}

export interface DeleteStorageAreaResponse {
  ok: true;
}

export function useDeleteStorageArea() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const store = useStorageAreaStore();

  return {
    execute
  };

  async function execute(action: DeleteStorageAreaRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`storagearea/${action.storageAreaId}`), {
      headers,
      method: 'DELETE'
    });
    const text = translations.value.storageAreas.actions.delete;
    const response = await httpClient.action<DeleteStorageAreaResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk() {
        store.remove(action.storageAreaId);
        return {
          ok: true
        };
      }
    });

    return response;
  }
}
